import { Button, Result } from "antd";

import { useNavigate } from "react-router-dom";

const NotFound = () => {

    let navigate = useNavigate();

    return <Result
        status="404"
        title="404"
        subTitle="Desculpe, essa página não existe."
        extra={<Button onClick={() => {
            navigate(-1)
        }} type="primary">Voltar</Button>}
    />
}

export default NotFound